import CountryCell from "pages/user/checkout/checkout-form/country-cell";
import { RESOURCES_SERVER_URL_PREFIX } from "api";

const countries = [
  {
    value: "srb", name: "Srbija", label: <CountryCell name="Srbija" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/serbia-48.png`} />
  },
  {
    value: "bih", name: "Bosna i Hercegovina", label: <CountryCell name="Bosna i Hercegovina" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/bosnia-and-herzegovina-48.png`} />
  },
  {
    value: "me", name: "Crna Gora", label: <CountryCell name="Crna Gora" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/montenegro-48.png`} />
  },
  {
    value: "hr", name: "Hrvatska", label: <CountryCell name="Hrvatska" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/croatia-48.png`} />
  },
  {
    value: "si", name: "Slovenija", label: <CountryCell name="Slovenija" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/slovenia-48.png`} />
  },
  {
    value: "mk", name: "Severna Makedonija", label: <CountryCell name="Severna Makedonija" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/macedonia-48.png`} />
  },
  {
    value: "de", name: "Njemačka", label: <CountryCell name="Njemačka" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/germany-48.png`} />
  },
  {
    value: "fr", name: "Francuska", label: <CountryCell name="Francuska" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/france-48.png`} />
  },
  {
    value: "at", name: "Austrija", label: <CountryCell name="Austrija" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/austria-48.png`} />
  },
  {
    value: "it", name: "Italija", label: <CountryCell name="Italija" image={`${RESOURCES_SERVER_URL_PREFIX}/static/icons/italy-48.png`} />
  },
]

export default countries;
